import {StyleSheet} from 'react-native';
import {FONTS} from '../../../utils/Constants';

// Theme-aware styles factory (docs/DARK-MODE.md). Style-as-function entries
// are preserved — the factory returns them closed over the theme's colors.
// Series fill + dot stroke use the chartSeriesFill token (light = legacy
// COLORS.blueGradient1 verbatim).
const makeStyles = colors =>
  StyleSheet.create({
    globalPadding: paddingVal => ({
      padding: 8,
    }),
    elementPadding: paddingVal => ({
      paddingHorizontal: paddingVal,
      marginTop: paddingVal,
    }),
    mainCardStyle: {
      borderRadius: 16,
      backgroundColor: colors.surface,
      overflow: 'hidden',
      paddingBottom: 16,
    },
    hitSlop: {top: 16, bottom: 16, left: 16, right: 16},
    centerItem: {justifyContent: 'center', alignItems: 'center'},
    titleStyle: {
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
    chartConfig: {
      backgroundColor: colors.surface,
      backgroundGradientFrom: colors.surface,
      backgroundGradientTo: colors.surface,
      fillShadowGradientFrom: colors.chartSeriesFill,
      fillShadowGradientFromOpacity: 0.5,
      fillShadowGradientTo: colors.surface,
      fillShadowGradientToOpacity: 0.2292,
      color: (opacity = 1) => colors.textMuted,
      labelColor: (opacity = 1) => colors.textMuted,
      propsForDots: {
        r: '6',
        fill: colors.surface,
        strokeWidth: '3',
        stroke: colors.chartSeriesFill,
      },
      // propsForHorizontalLabels: {
      //   translateY: 30,
      // },
      // propsForBackgroundLines: {
      //   strokeDasharray: '1,3', // background lines with dashes
      //   stroke: COLORS.grey4,
      // },
      propsForLabels: {
        fontFamily: FONTS.regularFont,
        fontSize: 14,
      },
    },
  });

export default makeStyles;
